// @ts-strict-ignore
import styled from 'styled-components';

import { colors, transition } from 'theme';

import { ButtonWithStyles } from './ButtonWithStyles';

export const PrimaryButton = styled(ButtonWithStyles).attrs({
  $textColor: (props) =>
    props.color || (props.reverse ? colors.waterBlue : colors.white),
})<{ $transparent?: boolean }>`
  transition: all ${transition};
  text-decoration: none;
  color: ${(props) => props.$textColor};
  background: ${(props) =>
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-nested-ternary
    props.reverse
      ? colors.white
      : props.green
      ? colors.turtleGreen
      : colors.waterBlue};

  ${(props) =>
    props.$transparent &&
    `
      background: transparent;
      border: 1px solid ${colors.white};`}

  &:hover {
    color: ${(props) => props.$textColor};
    text-decoration: none;
  }
  &:disabled {
    &:hover {
      background-color: ${colors.waterBlue};

      ${(props) =>
        props.$transparent &&
        `
      background-color: transparent;
      `}
    }
  }
`;
